import { render, staticRenderFns } from "./SendEgiftPanelDepositInfo.vue?vue&type=template&id=71cba083&scoped=true"
import script from "./SendEgiftPanelDepositInfo.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelDepositInfo.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelDepositInfo.vue?vue&type=style&index=0&id=71cba083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cba083",
  null
  
)

export default component.exports